thresholdSettings.classy.controller({
    name: 'ThresholdSettingsController',
    inject: ['$scope', '$rootScope', 'DateService', 'standardCudArrayFactory', 'HelpSystemModelService', '$modal',
        'SchoolModelService', 'SchoolThresholdsModelService', 'authServiceFactory', '$q', '$http'],
    init: function()
    {
        var id = this.authServiceFactory.getAuth().schoolID;
        this.$.versionNo = versionNo;  
        this.$.HelpSystemModelService = this.HelpSystemModelService;
        this.$.SchoolModelService = this.SchoolModelService;
        this.$rootScope.model = this.SchoolModelService; 
        this.$.SchoolThresholdsModelService = this.SchoolThresholdsModelService;
        this.$.item = this.SchoolModelService.data[0];
        this.$.threshItem = this.SchoolThresholdsModelService.get()[0];
        //this.$.worksheetCalc(this.$.threshItem); 
        //this.$.worksheetCalc2(this.$.threshItem);   
        this.$.currentYear = this.DateService.getCurrentYear();
        this.$.familyWorksheetActive = 0;
        this.$.childWorksheetActive = 0;
    },
    toggleFamilyWorksheet: function()
    {
        if (this.$.familyWorksheetActive==0) {
            this.$.worksheetCalc(this.$.threshItem);
        }
        else {
            //this.$.item.Thresh_Living_Allowance = this.$.origTLA;
            console.log(this.$.item.Thresh_Living_Allowance);
        }
        this.$.childWorksheetActive = 0;
        this.$.familyWorksheetActive = !this.$.familyWorksheetActive;
    },
    toggleChildWorksheet: function()
    {
        if (this.$.childWorksheetActive==0) {
            this.$.worksheetCalc2(this.$.threshItem);
        }
        else {
        }
        this.$.familyWorksheetActive = 0;
        this.$.childWorksheetActive = !this.$.childWorksheetActive;
    },
    startSaveProcess: function(scope, instance, form)
    {
        var id = this.authServiceFactory.getAuth().schoolID;
        var self = this;
        if (form.$valid)
        {
            instance.options.factor  = .3;
            this.SchoolThresholdsModelService.put(id, this.$.threshItem, instance);
            this.$.SchoolModelService.put(id, this.$.item, instance);
        }
        else
        {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) 
    {
        this.SchoolModelService.set(this.SchoolModelService.data);
        this.SchoolThresholdsModelService.set(this.SchoolThresholdsModelService.data);
        if (typeof callback !== 'undefined')
            callback();
    },
    worksheetCalc: function(item)
    {
        this.$.calc = {};
        this.$.calc.Food = item.Thresh_LA_Food * item.Worksheet_LA_Food;
        this.$.calc.Trans = item.Thresh_LA_Trans * item.Worksheet_LA_Trans;
        this.$.calc.House = item.Thresh_LA_House * item.Worksheet_LA_House;
        this.$.calc.Clothes = item.Thresh_LA_Clothes * item.Worksheet_LA_Clothes;
        this.$.calc.Personal = item.Thresh_LA_Personal * item.Worksheet_LA_Personal;
        this.$.calc.Entertain = item.Thresh_LA_Entertain * item.Worksheet_LA_Entertain;
        this.$.threshItem.Thresh_Living_Allowance = this.$.calc.Food + this.$.calc.Trans + this.$.calc.House + this.$.calc.Clothes + this.$.calc.Personal + this.$.calc.Entertain;
        //this.$.item.Thresh_Living_Allowance = this.$.threshItem.Thresh_Living_Allowance;
    },
    reset: function(item)
    {

        item.Thresh_LA_Food = 0;
        item.Worksheet_LA_Food = 1;
        item.Thresh_LA_Trans = 0;
        item.Worksheet_LA_Trans = 1;
        item.Thresh_LA_House = 0;
        item.Worksheet_LA_House = 1;
        item.Thresh_LA_Clothes = 0;
        item.Worksheet_LA_Clothes = 1;
        item.Thresh_LA_Personal = 0;
        item.Worksheet_LA_Personal = 1;
        item.Thresh_LA_Entertain = 0;
        item.Worksheet_LA_Entertain = 1;
        this.$.toggleFamilyWorksheet();
    },
    keep: function(item)
    {
        this.$.item.Thresh_Living_Allowance = this.$.threshItem.Thresh_Living_Allowance;
    },
    worksheetCalc2: function(item)
    {
        this.$.calc2 = {};
        this.$.calc2.Food = item.Thresh_CA_Food * item.Worksheet_CA_Food;
        this.$.calc2.Clothes = item.Thresh_CA_Clothes * item.Worksheet_CA_Clothes;
        this.$.calc2.Personal = item.Thresh_CA_Personal * item.Worksheet_CA_Personal;
        this.$.threshItem.Thresh_Allow_Per_Child = this.$.calc2.Food + this.$.calc2.Clothes + this.$.calc2.Personal;
        //this.$.item.Thresh_Allow_Per_Child = this.$.threshItem.Thresh_Allow_Per_Child;
    },
    reset2: function(item)
    {
        item.Thresh_CA_Food = 0;
        item.Worksheet_CA_Food = 1;
        item.Thresh_CA_Clothes = 0;
        item.Worksheet_CA_Clothes = 1;
        item.Thresh_CA_Personal  = 0;
        item.Worksheet_CA_Personal = 1;
        this.$.toggleChildWorksheet();
    },
    keep2: function()
    {
        this.$.item.Thresh_Allow_Per_Child = this.$.threshItem.Thresh_Allow_Per_Child;
    },
    applyToAll: function(value)
    {
        if (value == true) {
            this.$http.defaults.headers.common['applyToAll'] = 1;
            this.applyToAllModal();
        }
        else
            this.$http.defaults.headers.common['applyToAll'] = null;

    },
    activeChange: function(field)
    {
        this.$.threshItem[field] = Number(this.$.threshItem[field]);
    },
    activeChange2: function(field)
    {
        if (this.$.item[field]!=0)
            this.$.item[field] = Number(this.$.item[field]);
    },
    applyToAllModal: function()
    {
        var parent = this;
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/settings/awardSettings/thresholdSettings/partials/applyModal.html?v=" + versionNo,
            controller: "ApplyModalController"
        }).result.then(
            function() {}, //Success
            function() //Dismiss
            {
                parent.applyToAll(false);
                parent.$.applyAll = false;
            }
        );
    }
});